import React, { useEffect, useState, useMemo } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useAuth } from "../../AuthContext";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputMask } from "primereact/inputmask";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { format } from "date-fns";

import "primeicons/primeicons.css";

import {
  FaTag,
  FaShoppingCart,
  FaFileAlt,
  FaMinusCircle,
  FaCreditCard,
  FaCheckCircle,
  FaCalendarAlt,
  FaCalendarPlus,
  FaUserMd,
  FaBuilding,
  FaList,
  FaCalendarCheck,
  FaStickyNote,
  FaFileMedical,
  FaFileInvoiceDollar,
  FaUser,
  FaMapMarkerAlt,
  FaClock,
  FaCalendar,
  FaDollarSign,
  FaChartBar,
  FaHistory,
  FaFilter,
  FaIdCard,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";

const Despesas = () => {
  const { user } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [despesas, setDespesas] = useState([]);
  const [filtroDescricao, setFiltroDescricao] = useState("");
  const [visibleNovaDespesa, setVisibleNovaDespesa] = useState(false);
  const [visibleEditarDespesa, setVisibleEditarDespesa] = useState(false);

  // Estados para cadastro/edição
  const [despesaEditandoId, setDespesaEditandoId] = useState(null);
  const [categoria, setCategoria] = useState("");
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState(0);
  const [empresaId, setEmpresaId] = useState("");
  const [dataCadastro, setDataCadastro] = useState(null);
  const [ativo, setAtivo] = useState(true);

  // Lista de empresas para seleção
  const [empresas, setEmpresas] = useState([]);

  // Estados para os dialogs de confirmação
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const [mostrarFiltroDespesa, setMostrarFiltroDespesa] = useState(false);
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [filtroValor, setFiltroValor] = useState("");
  const [filtroEmpresaId, setFiltroEmpresaId] = useState("");
  const [mostrarCalendario, setMostrarCalendario] = useState(false);

  // Estados para Datas
  const [diaSelecionado, setDiaSelecionado] = useState(new Date());
  const [mesCalendario, setMesCalendario] = useState(new Date());

  // Estados para Deletar
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [itemDelete, setItemDelete] = useState(null);

  // Categorias disponíveis (pode vir de uma API no futuro)
  const categoriasDisponiveis = [
    "Alimentação",
    "Transporte",
    "Materiais",
    "Serviços",
    "Manutenção",
    "Outros",
  ];

  useEffect(() => {
    fetchDespesas();
    fetchEmpresas();
  }, []);

  // Despesas filtradas e ordenadas
  const despesasFiltradas = useMemo(() => {
    return despesas.filter((despesa) => {
      // Filtro por data (data_cadastro) - pode comparar com diaSelecionado
      const dataCadastro = despesa.data_atualizacao.split(" ")[0];
      const dataSelecionada = diaSelecionado
        ? diaSelecionado.toISOString().split("T")[0]
        : null;
      const dataMatch = !dataSelecionada || dataCadastro === dataSelecionada;

      // Filtro por categoria
      const categoriaMatch =
        !filtroCategoria ||
        despesa.categoria
          ?.toLowerCase()
          .includes(filtroCategoria.toLowerCase());

      // Filtro por descrição
      const descricaoMatch =
        !filtroDescricao ||
        despesa.descricao
          ?.toLowerCase()
          .includes(filtroDescricao.toLowerCase());

      // Filtro por valor (pode buscar por número ou texto)
      const valorMatch =
        !filtroValor ||
        despesa.valor
          ?.toString()
          .toLowerCase()
          .includes(filtroValor.toLowerCase());

      // Filtro por Empresa (pode buscar por número ou texto)
      const empresaMatch =
        !filtroEmpresaId ||
        despesa.empresa_id
          ?.toString()
          .toLowerCase()
          .includes(filtroEmpresaId.toLowerCase());

      // Retorna true apenas se TODOS os filtros ativos corresponderem
      return (
        dataMatch &&
        categoriaMatch &&
        descricaoMatch &&
        valorMatch &&
        empresaMatch
      );
    });
  }, [
    despesas,
    diaSelecionado,
    filtroCategoria,
    filtroDescricao,
    filtroValor,
    filtroEmpresaId,
  ]);

  const fetchDespesas = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/despesas",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        throw new Error("Erro ao buscar despesas");
      }

      const data = await response.json();

      console.log("Despesas = ", data.data);

      if (data.success && Array.isArray(data.data)) {
        setDespesas(data.data);
        setError(null);
      } else {
        setDespesas([]);
        setError("Nenhuma despesa encontrada.");
      }
    } catch (error) {
      setError(error.message);
      setDespesas([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchEmpresas = async () => {
    try {
      if (!user?.token) return;

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/empresas",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        if (data.success && Array.isArray(data.data)) {
          setEmpresas(data.data);
        }
      }
    } catch (error) {
      console.error("Erro ao buscar empresas:", error);
    }
  };

  const resetarCampos = () => {
    setCategoria("");
    setDescricao("");
    setValor(0);
    setEmpresaId("");
    setDataCadastro(null);
    setAtivo(true);
  };

  const handleSalvar = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      // Verificação dos campos obrigatórios
      if (!categoria || !descricao || !valor || !empresaId) {
        setDialogMessage("Preencha todos os campos obrigatórios");
        setShowErrorDialog(true);
        return;
      }

      if (valor <= 0) {
        setDialogMessage("O valor deve ser maior que zero");
        setShowErrorDialog(true);
        return;
      }

      const despesaData = {
        categoria: categoria,
        descricao: descricao,
        valor: valor,
        empresa_id: empresaId,
        ativo: "1",
      };

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/despesas",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(despesaData),
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Falha ao cadastrar despesa");
      }

      await response.json();
      setDialogMessage("Despesa cadastrada com sucesso!");
      setShowSuccessDialog(true);
      fetchDespesas();
      setVisibleNovaDespesa(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro detalhado ao salvar:", err);
      setDialogMessage(err.message || "Erro ao cadastrar despesa");
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEditar = async (despesaId) => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      if (!categoria || !descricao || !valor) {
        setDialogMessage("Preencha todos os campos obrigatórios");
        setShowErrorDialog(true);
        return;
      }

      if (valor <= 0) {
        setDialogMessage("O valor deve ser maior que zero");
        setShowErrorDialog(true);
        return;
      }

      const despesaData = {
        categoria: categoria,
        descricao: descricao,
        valor: valor,
        empresa_id: empresaId,
        ativo: ativo ? "1" : "0",
      };

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/despesas/${despesaId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(despesaData),
        },
      );

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData?.message ||
          responseData?.data?.message ||
          `Erro HTTP ${response.status}`;
        throw new Error(errorMessage);
      }

      setDialogMessage("Despesa atualizada com sucesso!");
      setShowSuccessDialog(true);
      fetchDespesas();
      setVisibleEditarDespesa(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro na edição:", err);
      setDialogMessage(
        err.message.includes("não encontrada")
          ? "Despesa não encontrada ou já removida"
          : err.message,
      );
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  // Função para abrir o diálogo de confirmação
  const openDeleteConfirm = (id) => {
    setItemDelete(id);
    setShowConfirmDialog(true);
  };

  const handleExcluir = async (itemDelete) => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      console.log("itemDelete = ", itemDelete);

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/despesas/${itemDelete}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData?.message ||
          responseData?.data?.message ||
          `Erro HTTP ${response.status}`;
        throw new Error(errorMessage);
      }

      setDialogMessage("Despesa excluída com sucesso!");
      setShowSuccessDialog(true);
      fetchDespesas();
    } catch (err) {
      console.error("Erro na exclusão:", err);
      setDialogMessage(
        err.message.includes("não encontrada")
          ? "Despesa não encontrada ou já removida"
          : err.message,
      );
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  // Formatar data para exibição
  const formatarData = (dataString) => {
    if (!dataString) return "";
    try {
      return format(new Date(dataString), "dd/MM/yyyy");
    } catch {
      return dataString;
    }
  };

  {
    /* --------------------------------------- Calendario --------------------------------------- */
  }
  const verificarReservasNoDia = (data) => {
    if (!despesas || despesas.length === 0) return false;

    const dataFormatada = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}-${String(data.getDate()).padStart(2, "0")}`;

    return despesas.some(
      (despesa) => despesa.data_cadastro?.split(" ")[0] === dataFormatada,
    );
  };

  const gerarDiasCalendario = () => {
    const ano = mesCalendario.getFullYear();
    const mes = mesCalendario.getMonth();

    const primeiroDia = new Date(ano, mes, 1);
    const ultimoDia = new Date(ano, mes + 1, 0);
    const diaSemanaInicio = primeiroDia.getDay();

    const dias = [];

    // Dias do mês anterior
    for (let i = diaSemanaInicio - 1; i >= 0; i--) {
      const data = new Date(ano, mes, -i);
      dias.push({
        data,
        disponivel: true,
        selecionado: false,
        possuiReserva: verificarReservasNoDia(data),
        outroMes: true,
      });
    }

    // Dias do mês atual
    for (let dia = 1; dia <= ultimoDia.getDate(); dia++) {
      const data = new Date(ano, mes, dia);

      // ✅ CORRETO - formatação manual para comparação
      const dataFormatada = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}-${String(data.getDate()).padStart(2, "0")}`;
      const diaSelecionadoFormatado = `${diaSelecionado.getFullYear()}-${String(diaSelecionado.getMonth() + 1).padStart(2, "0")}-${String(diaSelecionado.getDate()).padStart(2, "0")}`;

      const selecionado = diaSelecionadoFormatado === dataFormatada;
      const possuiReserva = verificarReservasNoDia(data);

      dias.push({
        data,
        disponivel: true,
        selecionado,
        possuiReserva,
        outroMes: false,
      });
    }

    // Completar com dias do próximo mês
    const totalCells = 42;
    while (dias.length < totalCells) {
      const data = new Date(
        ano,
        mes + 1,
        dias.length - ultimoDia.getDate() - diaSemanaInicio + 1,
      );
      dias.push({
        data,
        disponivel: true,
        selecionado: false,
        possuiReserva: verificarReservasNoDia(data),
        outroMes: true,
      });
    }

    return dias;
  };

  const handleSelecionarDia = (dia) => {
    if (!dia.disponivel) return;

    setDiaSelecionado(new Date(dia.data));
  };

  const handleMudarMes = (direcao) => {
    const novoMes = new Date(mesCalendario);
    if (direcao === "proximo") {
      novoMes.setMonth(novoMes.getMonth() + 1);
    } else {
      novoMes.setMonth(novoMes.getMonth() - 1);
    }
    setMesCalendario(novoMes);
  };

  // Adicione estas funções perto das outras funções utilitárias (após handleSelecionarDia):
  const irParaDiaAnterior = () => {
    const novoDia = new Date(diaSelecionado);
    novoDia.setDate(novoDia.getDate() - 1);
    setDiaSelecionado(novoDia);
  };

  const irParaProximoDia = () => {
    const novoDia = new Date(diaSelecionado);
    novoDia.setDate(novoDia.getDate() + 1);
    setDiaSelecionado(novoDia);
  };

  {
    /* Return Principal */
  }
  return (
    <div
      style={{
        fontFamily: "'Rajdhani', sans-serif",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Dialog de Sucesso */}
      <Dialog
        visible={showSuccessDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowSuccessDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#22C55E",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-check-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            icon="pi pi-check"
            onClick={() => setShowSuccessDialog(false)}
            className="p-button-success"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog de Erro */}
      <Dialog
        visible={showErrorDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowErrorDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#EF4444",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-times-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            onClick={() => setShowErrorDialog(false)}
            className="p-button-danger"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog de Confirmação */}
      <Dialog
        visible={showConfirmDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowConfirmDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#ef4444",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-question-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            Tem certeza que deseja excluir esta despesa?
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "12px",
              width: "100%",
            }}
          >
            <Button
              label="NÃO"
              icon="pi pi-times"
              onClick={() => setShowConfirmDialog(false)}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "6px 20px",
                minWidth: "100px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
            />
            <Button
              label="SIM"
              icon="pi pi-check"
              onClick={() => {
                handleExcluir(itemDelete);
                setShowConfirmDialog(false);
              }}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "6px 20px",
                minWidth: "100px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
            />
          </div>
        </div>
      </Dialog>

      {/* Dialog Nova Despesa */}
      <Dialog
        visible={visibleNovaDespesa}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleNovaDespesa(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaFileInvoiceDollar
                  style={{ fontSize: "2.4rem", color: "#B83732" }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  ADICIONAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  DESPESA
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "10px 0" }}>
            {/* 1ª Linha - Categoria e Empresa */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Categoria */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom:
                        "2px solid #3498DB" /* Azul padrão para nome */,
                    }}
                  >
                    <FaTag style={{ color: "#3498DB", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Categoria *
                    </span>
                  </div>
                  <Dropdown
                    value={categoria}
                    onChange={(e) => setCategoria(e.value)}
                    options={categoriasDisponiveis.map((cat) => ({
                      label: cat,
                      value: cat,
                    }))}
                    placeholder="Selecione a categoria"
                    className="p-inputtext-sm"
                    style={{
                      outline: "none",
                      boxShadow: "none",
                      width: "100%",
                      height: "35px",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                    }}
                    panelStyle={{
                      fontFamily: "'Rajdhani', sans-serif",
                      fontSize: "0.9rem",
                    }}
                    itemTemplate={(option) => (
                      <span
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                          padding: "8px 12px",
                        }}
                      >
                        {option.label}
                      </span>
                    )}
                    valueTemplate={(option, props) => {
                      if (!option)
                        return (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              color: "#7f8c8d",
                            }}
                          >
                            {props.placeholder}
                          </span>
                        );
                      return (
                        <span
                          style={{
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: "0.9rem",
                          }}
                        >
                          {option.label}
                        </span>
                      );
                    }}
                  />
                </div>
              </div>

              {/* Card Empresa */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #16A085",
                    }}
                  >
                    <FaBuilding
                      style={{ color: "#16A085", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Empresa *
                    </span>
                  </div>
                  <Dropdown
                    value={empresaId}
                    onChange={(e) => setEmpresaId(e.value)}
                    options={empresas.map((emp) => ({
                      label: emp.nome,
                      value: emp.id,
                    }))}
                    placeholder="Selecione a empresa"
                    className="p-inputtext-sm"
                    style={{
                      outline: "none",
                      boxShadow: "none",
                      width: "100%",
                      height: "35px",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                    }}
                    panelStyle={{
                      fontFamily: "'Rajdhani', sans-serif",
                      fontSize: "0.9rem",
                    }}
                    itemTemplate={(option) => (
                      <span
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                          padding: "8px 12px",
                        }}
                      >
                        {option.label}
                      </span>
                    )}
                    valueTemplate={(option, props) => {
                      if (!option)
                        return (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              color: "#7f8c8d",
                            }}
                          >
                            {props.placeholder}
                          </span>
                        );
                      return (
                        <span
                          style={{
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: "0.9rem",
                          }}
                        >
                          {option.label}
                        </span>
                      );
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 2ª Linha - Valor e Descrição  */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Valor */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom:
                        "2px solid #27AE60" /* Azul mais escuro para telefone */,
                    }}
                  >
                    <FaDollarSign
                      style={{ color: "#27AE60", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Valor *
                    </span>
                  </div>
                  <InputText
                    value={valor}
                    onChange={(e) => {
                      // Validação para permitir apenas números e ponto decimal
                      const value = e.target.value;
                      const regex = /^\d*\.?\d*$/;
                      if (value === "" || regex.test(value)) {
                        setValor(value);
                      }
                    }}
                    placeholder="0.00"
                    className="p-inputtext-sm"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                      fontSize: "1rem",
                      fontWeight: "500",
                    }}
                    onBlur={(e) => {
                      // Formata o valor com 2 casas decimais ao perder o foco
                      const numValue = parseFloat(e.target.value);
                      if (!isNaN(numValue)) {
                        setValor(numValue.toFixed(2));
                      }
                    }}
                  />
                </div>
              </div>

              {/* Card Descrição */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaFileAlt
                      style={{ color: "#E67E22", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Descrição *
                    </span>
                  </div>
                  <InputText
                    id="descricao"
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                    style={{
                      outline: "none",
                      boxShadow: "none",
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                      fontSize: "1rem",
                      fontWeight: "500",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                resetarCampos();
                setVisibleNovaDespesa(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "CADASTRAR DESPESA"}
              icon="pi pi-check"
              onClick={handleSalvar}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={
                loading || !categoria || !empresaId || !valor || !descricao
              }
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Dialog Editar Despesa */}
      <Dialog
        visible={visibleEditarDespesa}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleEditarDespesa(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-25px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaFileInvoiceDollar
                  style={{ fontSize: "2.4rem", color: "#B83732" }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  EDITAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  DESPESA
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "10px 0" }}>
            {/* 1ª Linha - Categoria e Empresa */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Categoria */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom:
                        "2px solid #3498DB" /* Azul padrão para nome */,
                    }}
                  >
                    <FaTag style={{ color: "#3498DB", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Categoria *
                    </span>
                  </div>
                  <Dropdown
                    value={categoria}
                    onChange={(e) => setCategoria(e.value)}
                    options={categoriasDisponiveis.map((cat) => ({
                      label: cat,
                      value: cat,
                    }))}
                    placeholder="Selecione a categoria"
                    className="p-inputtext-sm"
                    style={{
                      outline: "none",
                      boxShadow: "none",
                      width: "100%",
                      height: "35px",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                    }}
                    panelStyle={{
                      fontFamily: "'Rajdhani', sans-serif",
                      fontSize: "0.9rem",
                    }}
                    itemTemplate={(option) => (
                      <span
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                          padding: "8px 12px",
                        }}
                      >
                        {option.label}
                      </span>
                    )}
                    valueTemplate={(option, props) => {
                      if (!option)
                        return (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              color: "#7f8c8d",
                            }}
                          >
                            {props.placeholder}
                          </span>
                        );
                      return (
                        <span
                          style={{
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: "0.9rem",
                          }}
                        >
                          {option.label}
                        </span>
                      );
                    }}
                  />
                </div>
              </div>

              {/* Card Empresa */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #16A085",
                    }}
                  >
                    <FaBuilding
                      style={{ color: "#16A085", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Empresa *
                    </span>
                  </div>
                  <Dropdown
                    value={empresaId}
                    onChange={(e) => setEmpresaId(e.value)}
                    options={empresas.map((emp) => ({
                      label: emp.nome,
                      value: emp.id,
                    }))}
                    placeholder="Selecione a empresa"
                    className="p-inputtext-sm"
                    style={{
                      outline: "none",
                      boxShadow: "none",
                      width: "100%",
                      height: "35px",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                    }}
                    panelStyle={{
                      fontFamily: "'Rajdhani', sans-serif",
                      fontSize: "0.9rem",
                    }}
                    itemTemplate={(option) => (
                      <span
                        style={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                          padding: "8px 12px",
                        }}
                      >
                        {option.label}
                      </span>
                    )}
                    valueTemplate={(option, props) => {
                      if (!option)
                        return (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              color: "#7f8c8d",
                            }}
                          >
                            {props.placeholder}
                          </span>
                        );
                      return (
                        <span
                          style={{
                            fontFamily: "'Rajdhani', sans-serif",
                            fontSize: "0.9rem",
                          }}
                        >
                          {option.label}
                        </span>
                      );
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 2ª Linha - Valor e Descrição  */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Card Valor */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom:
                        "2px solid #27AE60" /* Azul mais escuro para telefone */,
                    }}
                  >
                    <FaDollarSign
                      style={{ color: "#27AE60", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Telefone *
                    </span>
                  </div>
                  <InputText
                    value={valor}
                    onChange={(e) => {
                      // Validação para permitir apenas números e ponto decimal
                      const value = e.target.value;
                      const regex = /^\d*\.?\d*$/;
                      if (value === "" || regex.test(value)) {
                        setValor(value);
                      }
                    }}
                    placeholder="0.00"
                    className="p-inputtext-sm"
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                      fontSize: "1rem",
                      fontWeight: "500",
                    }}
                    onBlur={(e) => {
                      // Formata o valor com 2 casas decimais ao perder o foco
                      const numValue = parseFloat(e.target.value);
                      if (!isNaN(numValue)) {
                        setValor(numValue.toFixed(2));
                      }
                    }}
                  />
                </div>
              </div>

              {/* Card Descrição */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaFileAlt
                      style={{ color: "#E67E22", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Descrição *
                    </span>
                  </div>
                  <InputText
                    id="descricao"
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                    style={{
                      outline: "none",
                      boxShadow: "none",
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "0 10px",
                      fontSize: "1rem",
                      fontWeight: "500",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                resetarCampos();
                setVisibleEditarDespesa(false);
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "SALVAR ALTERAÇÕES"}
              icon="pi pi-check"
              onClick={() => handleEditar(despesaEditandoId)}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={
                loading || !categoria || !empresaId || !valor || !descricao
              }
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Barra superior vermelha */}
      <div
        style={{
          backgroundColor: "#B83732",
          height: "40px",
          minHeight: "40px",
          width: "100%",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          fontWeight: "bold",
          position: "fixed",
          zIndex: 1, 
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* lado esquerdo */}
        <div></div>

        {/* Centro */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            icon="pi pi-refresh"
            className="icon-button-titulo"
            onClick={() => {
              fetchDespesas();
              setDiaSelecionado(new Date());
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={mostrarFiltroDespesa ? "pi pi-filter-slash" : "pi pi-filter"}
            className="icon-button-titulo"
            onClick={() => {
              setMostrarFiltroDespesa(!mostrarFiltroDespesa);
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={
              mostrarCalendario ? "pi pi-calendar-minus" : "pi pi-calendar-plus"
            }
            className="icon-button-titulo"
            onClick={() => {
              setMostrarCalendario(!mostrarCalendario);
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon="pi pi-plus"
            className="icon-button-titulo"
            onClick={() => {
              if (
                user.tipo === "administrator" ||
                user.modulos?.Financeiro?.editar
              ) {
                setVisibleNovaDespesa(true);
                resetarCampos();
              }
            }}
            disabled={
              !(
                user.tipo === "administrator" ||
                user.modulos?.Financeiro?.editar
              )
            }
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              opacity:
                user.tipo === "administrator" ||
                user.modulos?.Financeiro?.editar
                  ? 1
                  : 0.4,
              cursor:
                user.tipo === "administrator" ||
                user.modulos?.Financeiro?.editar
                  ? "pointer"
                  : "not-allowed",
            }}
            outlined
          />
        </div>

        {/* lado direito */}
        <div></div>
      </div>

      {/* Conteúdo abaixo da barra */}
      <div style={{ flex: 1, padding: "50px 10px" }}>
        {/* MOSTRAR RESERVAS DO DIA SELECIONADO - SEMPRE VISÍVEL */}
        <div style={{ borderRadius: "8px", padding: "0 15px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #E2E8F0",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <FaFileInvoiceDollar
                style={{ color: "#B83732", fontSize: "1.2rem" }}
              />
              <h3 style={{ margin: 0, color: "#424242" }}>DESPESAS</h3>
            </div>
            <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
              <Button
                icon="pi pi-chevron-left"
                className="p-button-text p-button-sm"
                onClick={irParaDiaAnterior}
                tooltip="Dia anterior"
                style={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                  color: "#424242",
                }}
              />
              <h3 style={{ margin: 0, color: "#424242" }}>
                {diaSelecionado.toLocaleDateString("pt-BR")}
              </h3>
              <Button
                icon="pi pi-chevron-right"
                className="p-button-text p-button-sm"
                onClick={irParaProximoDia}
                tooltip="Próximo Dia"
                style={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                  color: "#424242",
                }}
              />
            </div>
          </div>

          {/* InputSwitch */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              marginBottom: "30px",
            }}
          ></div>

          {/* Calendário Visual */}
          {mostrarCalendario && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    borderRadius: "8px",
                    padding: "10px 8px",
                    border: "1px solid #dee2e6",
                    backgroundColor: "#fff",
                    width: "95%",
                    maxWidth: "920px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                  }}
                >
                  {/* Navegação do mês - MANTIDA */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "5px",
                    }}
                  >
                    <Button
                      icon="pi pi-chevron-left"
                      className="p-button-text p-button-sm"
                      onClick={() => handleMudarMes("anterior")}
                      style={{
                        border: "none",
                        outline: "none",
                        boxShadow: "none",
                        color: "#424242",
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "bold",
                        color: "#424242",
                      }}
                    >
                      {mesCalendario
                        .toLocaleDateString("pt-BR", {
                          month: "long",
                          year: "numeric",
                        })
                        .toUpperCase()}
                    </span>
                    <Button
                      icon="pi pi-chevron-right"
                      className="p-button-text p-button-sm"
                      onClick={() => handleMudarMes("proximo")}
                      style={{
                        border: "none",
                        outline: "none",
                        boxShadow: "none",
                        color: "#424242",
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  </div>

                  {/* Grid do calendário - NOVO LAYOUT */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(7, 1fr)",
                      gap: "2px",
                      marginBottom: "10px",
                    }}
                  >
                    {/* Cabeçalho dos dias da semana */}
                    {["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"].map(
                      (dia) => (
                        <div
                          key={dia}
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            padding: "5px 2px",
                            backgroundColor: "#e9ecef",
                            borderRadius: "3px",
                            fontSize: "0.8rem",
                            color: "#495057",
                          }}
                        >
                          {dia}
                        </div>
                      ),
                    )}

                    {/* Dias do calendário - NOVO ESTILO */}
                    {gerarDiasCalendario().map((dia, index) => {
                      // Determinar se o dia é clicável
                      const clicavel =
                        dia.disponivel !== false || // Se tiver a propriedade disponivel
                        (dia.possuiReserva && dia.disponivel !== false); // Ou se tiver reserva mas não está marcado como indisponível

                      // Cor de fundo baseada no estado
                      let backgroundColor = "#ffffff"; // Padrão

                      if (dia.selecionado) {
                        backgroundColor = "#fff0f0"; // Azul para selecionado
                      } else if (dia.outroMes) {
                        backgroundColor = "#f8f9fa"; // Cinza claro para outros meses
                      } else if (dia.possuiReserva) {
                        backgroundColor = "#e8f5e9"; // Verde claro para dias com reserva
                      }

                      // Cor do texto
                      let color = "#424242";
                      if (dia.outroMes) {
                        color = "#adb5bd";
                      } else if (dia.selecionado) {
                        color = "#b83732";
                      } else if (dia.possuiReserva) {
                        color = "#28a745";
                      }

                      // Cor da borda
                      let borderColor = "#dee2e6";
                      if (dia.selecionado) {
                        borderColor = "#a8322d";
                      } else if (dia.possuiReserva) {
                        borderColor = "#28a745";
                      }

                      return (
                        <div
                          key={index}
                          onClick={() => clicavel && handleSelecionarDia(dia)}
                          style={{
                            textAlign: "center",
                            padding: "8px 1px",
                            backgroundColor: backgroundColor,
                            borderRadius: "4px",
                            cursor: clicavel ? "pointer" : "not-allowed",
                            border: `1px solid ${borderColor}`,
                            fontWeight: dia.selecionado ? "bold" : "normal",
                            color: dia.selecionado ? "#b83732" : color, // Branco quando selecionado
                            position: "relative",
                            height: "45px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "0.85rem",
                            opacity: dia.outroMes ? 0.6 : 1,
                            transition:
                              "background-color 0.2s ease, border-color 0.2s ease",
                            boxSizing: "border-box",
                          }}
                          className={clicavel ? "day-hover" : ""}
                          title={
                            dia.possuiReserva
                              ? "Tem reservas neste dia"
                              : dia.outroMes
                                ? "Outro mês"
                                : "Dia disponível"
                          }
                        >
                          <div
                            style={{
                              fontWeight:
                                dia.data.getDate() === new Date().getDate() &&
                                !dia.outroMes
                                  ? "bold"
                                  : "normal",
                              fontSize: "0.85rem",
                            }}
                          >
                            {dia.data.getDate()}
                          </div>

                          {/* BOLINHA PARA DIAS COM RESERVA */}
                          {dia.possuiReserva && !dia.outroMes && (
                            <div
                              style={{
                                position: "absolute",
                                top: "3px",
                                right: "3px",
                                width: "8px",
                                height: "8px",
                                backgroundColor: "#28a745",
                                borderRadius: "50%",
                                border: dia.selecionado
                                  ? "1px solid #28a745"
                                  : "none",
                              }}
                            />
                          )}

                          {/* Indicador se é hoje */}
                          {dia.data.getDate() === new Date().getDate() &&
                            dia.data.getMonth() === new Date().getMonth() &&
                            dia.data.getFullYear() ===
                              new Date().getFullYear() &&
                            !dia.outroMes && (
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "2px",
                                  width: "4px",
                                  height: "4px",
                                  backgroundColor: dia.selecionado
                                    ? "#ffffff"
                                    : "#007bff",
                                  borderRadius: "50%",
                                }}
                              />
                            )}
                        </div>
                      );
                    })}
                  </div>

                  {/* Legenda - NOVA */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "15px",
                      flexWrap: "wrap",
                      fontSize: "0.75rem",
                      paddingTop: "10px",
                      borderTop: "1px solid #e0e0e0",
                    }}
                  >
                    {/* Selecionado */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <div
                        style={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: "#b83732",
                          borderRadius: "2px",
                        }}
                      ></div>
                      <span style={{ color: "#6c757d" }}>Selecionado</span>
                    </div>

                    {/* Com agenda/reserva */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <div
                        style={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: "#28a745",
                          borderRadius: "2px",
                        }}
                      ></div>
                      <span style={{ color: "#6c757d" }}>Com agenda</span>
                    </div>

                    {/* Hoje (opcional) */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <div
                        style={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #007bff",
                          borderRadius: "2px",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            bottom: "1px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: "4px",
                            height: "4px",
                            backgroundColor: "#007bff",
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                      <span style={{ color: "#6c757d" }}>Hoje</span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Filtros*/}
          {mostrarFiltroDespesa && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  borderRadius: "8px",
                  padding: "10px 8px",
                  border: "1px solid #dee2e6",
                  backgroundColor: "#fff",
                  width: "95%",
                  maxWidth: "920px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                {/* 1ª Linha - Categoria  e CPF */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "10px",
                  }}
                >
                  {/* Card Categoria  */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #3498DB",
                        }}
                      >
                        <FaTag
                          style={{ color: "#3498DB", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Categoria{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Nome da Categoria"
                        value={filtroCategoria}
                        onChange={(e) => setFiltroCategoria(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card Descrição  */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #16A085",
                        }}
                      >
                        <FaBuilding
                          style={{ color: "#16A085", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Empresa{" "}
                        </span>
                      </div>
                      <Dropdown
                        value={filtroEmpresaId}
                        onChange={(e) => setFiltroEmpresaId(e.value)}
                        options={empresas.map((emp) => ({
                          label: emp.nome,
                          value: emp.id,
                        }))}
                        placeholder="Selecione a empresa"
                        className="p-inputtext-sm"
                        style={{
                          width: "100%",
                          height: "35px",
                          border: "1px solid #dee2e6",
                          borderRadius: "4px",
                        }}
                        panelStyle={{
                          fontFamily: "'Rajdhani', sans-serif",
                          fontSize: "0.9rem",
                        }}
                        itemTemplate={(option) => (
                          <span
                            style={{
                              fontFamily: "'Rajdhani', sans-serif",
                              fontSize: "0.9rem",
                              padding: "8px 12px",
                            }}
                          >
                            {option.label}
                          </span>
                        )}
                        valueTemplate={(option, props) => {
                          if (!option)
                            return (
                              <span
                                style={{
                                  fontFamily: "'Rajdhani', sans-serif",
                                  fontSize: "0.9rem",
                                  color: "#7f8c8d",
                                }}
                              >
                                {props.placeholder}
                              </span>
                            );
                          return (
                            <span
                              style={{
                                fontFamily: "'Rajdhani', sans-serif",
                                fontSize: "0.9rem",
                              }}
                            >
                              {option.label}
                            </span>
                          );
                        }}
                        showClear
                      />
                    </div>
                  </div>

                  {/* Card Valor */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #27ae60",
                        }}
                      >
                        <FaDollarSign
                          style={{ color: "#27ae60", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Valor{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Valor"
                        value={filtroValor}
                        onChange={(e) => setFiltroValor(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card Email */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #e67e22",
                        }}
                      >
                        <FaEnvelope
                          style={{ color: "#e67e22", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Descrição{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Descrição"
                        value={filtroDescricao}
                        onChange={(e) => setFiltroDescricao(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Grids */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 8px",
            }}
          >
            {despesasFiltradas.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  border: "2px dashed #e8e8e8",
                }}
              >
                <FaFileInvoiceDollar
                  style={{
                    fontSize: "3rem",
                    color: "#B83732",
                    marginBottom: "15px",
                    opacity: 0.5,
                  }}
                />
                <h3
                  style={{
                    color: "#2c3e50",
                    margin: "0 0 10px 0",
                    fontSize: "1.2rem",
                    fontWeight: "600",
                  }}
                >
                  Nenhuma despesa encontrada
                </h3>
              </div>
            ) : (
              <div
                className="grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", // Alterado para 280px
                  gap: "15px",
                  alignItems: "stretch",
                }}
              >
                {despesasFiltradas.map((item, idx) => (
                  <div key={idx}>
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        padding: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      {/* Informações do Paciente */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          marginBottom: "5px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #e8e8e8",
                        }}
                      >
                        <FaFileInvoiceDollar
                          style={{
                            fontSize: "2.5rem",
                            color: "#D65A55",
                            flexShrink: 0,
                          }}
                        />
                        <div style={{ flex: 1 }}>
                          <h3
                            style={{
                              fontSize: "1rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                              margin: "0",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.categoria}
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color: "#64748b",
                              fontSize: "0.85rem",
                            }}
                          >
                            {item.descricao}
                          </div>
                        </div>
                      </div>

                      {/* Detalhes do Agendamento */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "6px",
                          marginBottom: "5px",
                        }}
                      >
                        {/* Coluna 1 */}
                        <div
                          style={{
                            display: "flex",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e8e8e8",
                            padding: "6px",
                            borderRadius: "6px",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FaCalendarAlt
                              style={{ color: "#2ecc71", fontSize: "0.75rem" }}
                            />{" "}
                            {/* Reduzido */}
                            <span
                              style={{
                                fontSize: "0.8rem", // Reduzido
                                color: "#2c3e50",
                                fontWeight: "500",
                              }}
                            >
                              {formatarData(item.data_cadastro)}
                            </span>
                          </div>
                        </div>

                        {/* Coluna 2 */}
                        <div
                          style={{
                            display: "flex",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e8e8e8",
                            padding: "6px",
                            borderRadius: "6px",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FaBuilding
                              style={{ color: "#3498db", fontSize: "0.75rem" }}
                            />{" "}
                            {/* Reduzido */}
                            <span
                              style={{
                                fontSize: "0.8rem", // Reduzido
                                color: "#2c3e50",
                                fontWeight: "500",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {
                                empresas.find((e) => e.id == item.empresa_id)
                                  ?.nome
                              }
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Valor */}
                      <div
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #e8e8e8",
                          padding: "6px",
                          borderRadius: "6px",
                          marginBottom: "6px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <FaDollarSign
                            style={{
                              color: "#e74c3c",
                              fontSize: "0.75rem",
                            }}
                          />
                          <span
                            style={{
                              fontSize: "0.85rem",
                              color: "#2c3e50",
                              fontWeight: "500",
                              display: "block",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            R${" "}
                            {parseFloat(item.valor).toLocaleString("pt-BR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                        </div>
                      </div>

                      {/* Ações Secundárias */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          paddingTop: "5px",
                          gap: "5px",
                          marginTop: "auto",
                          borderTop: "1px solid #e8e8e8",
                        }}
                      >
                        <Button
                          icon="pi pi-file-edit"
                          onClick={() => {
                            if (
                              user.tipo === "administrator" ||
                              user.modulos?.Financeiro?.editar
                            ) {
                              setDespesaEditandoId(item.id);
                              setCategoria(item.categoria || "");
                              setDescricao(item.descricao || "");
                              setValor(parseFloat(item.valor) || 0);
                              setEmpresaId(item.empresa_id || "");
                              setDataCadastro(item.data_cadastro || null);
                              setAtivo(item.ativo === "1");
                              setVisibleEditarDespesa(true);
                            }
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Financeiro?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                          }}
                          tooltip="Editar"
                          tooltipOptions={{ position: "top" }}
                        />
                        <Button
                          icon="pi pi-trash"
                          onClick={() => {
                            setShowConfirmDialog(true);
                            openDeleteConfirm(item.id);
                          }}
                          disabled={
                            !(
                              user.tipo === "administrator" ||
                              user.modulos?.Financeiro?.editar
                            )
                          }
                          className="p-button-outlined p-button-sm"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "25px",
                            height: "25px",
                            borderColor: "#dee2e6",
                            color: "#495057",
                          }}
                          tooltip="Excluir"
                          tooltipOptions={{ position: "top" }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Loading Spinner */}
        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="8"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Despesas;
